// import * as api from '../api'
import * as types from "../constants/action-types";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.min.css";
import axiosClient from "../services/axios";
import Axios from "axios";

/********** Product Action ********/
// recieve products
const user = JSON.parse(localStorage.getItem("delyork_user"));

const token = localStorage.getItem("delyork_token");

export const receiveProducts = (products) => ({
	type: types.RECEIVE_PRODUCTS,
	products,
});

// refresh local storage

export const refreshUnSafe = (current) => ({
	type: types.REFRESH_STORE,
	current,
});

export const refreshStore = (current) => (dispatch) => {
	dispatch(refreshUnSafe(current));
};

// get all products
export const getAllProducts = () => (dispatch) => {
	// api.getProducts().then( products => {
	//     dispatch( receiveProducts( products ) );
	//     return products;
	// } )
};

/*********** Modal related Action **********/
// display quickview
export const showQuickViewModal = (product) => ({
	type: types.SHOW_QUICKVIEW,
	product,
});

// close quickview modal
export const closeQuickViewModal = () => ({
	type: types.CLOSE_QUICKVIEW,
});

// Show Video & Login modal
export const showModal = (modal) => ({
	type: types.SHOW_MODAL,
	modal: modal,
});

export const startShowModal = (modal) => {
	return async (dispatch) => {
		dispatch(showModal(modal));
	};
};

// close Video & Login modal
export const closeModal = (modal) => ({
	type: types.CLOSE_MODAL,
	modal: modal,
});

// don't show Newsletter modal
export const removeNewsletterMdoal = (modal) => ({
	type: types.REMOVE_NEWSLETTER,
});

/************ Cart Action **************/
// add item to cart
export const addToCart = (product, qty) => (dispatch) => {
	// return    console.log(product)
	console.log("i am called lol");
	const token = localStorage.getItem("delyork_token");
	if (!token) {
		axiosClient
			.post(`/tempcart/${localStorage.getItem("cart_id")}`, {
				product_id: product.id,
				quantity: qty,
			})
			.then((data) => {
				toast.success("Item Added to Cart");
				//     const item =  data.data.data.associatedModel
				//     dispatch( addToCartUnsafe( item, qty ) );
				dispatch(setCartAction(data.data));
			})
			.catch((e) => {
				console.log(e);
			});
	} else {
		axiosClient
			.post(
				`/cart`,
				{
					product_id: product.id,
					quantity: qty,
				},
				{
					headers: {
						Authorization: `Bearer ${token}`,
					},
				}
			)
			.then((data) => {
				toast.success("Item Added to Cart");
				//    const item =  data.data.data.associatedModel
				//     dispatch( addToCartUnsafe( item, qty ) );
				console.log("cart-testing", data.data);
				dispatch(setCartAction(data.data));
			});
	}
};

// add item to cart : typical action
export const setCartAction = (products) => ({
	type: types.SET_TO_CART,
	cart: products,
});

export const setTempCart = () => (dispatch) => {
	// toast.success( "Item Added to Cart" );
	const token = localStorage.getItem("delyork_token");
	if (!token) {
		const session = localStorage.getItem("cart_id");
		axiosClient
			.get(`tempcart/${session}`, {
				headers: {
					Authorization: `Bearer ${token}`,
				},
			})
			.then((data) => {
				const items = data.data;
				dispatch(setCartAction(items));
				return items;
			})
			.catch((error) => {
				console.log(error);
			});
	} else {
		axiosClient
			.get(`cart`, {
				headers: {
					Authorization: `Bearer ${token}`,
				},
			})
			.then((data) => {
				const items = data.data;
				console.log("cart items2", items);
				dispatch(setCartAction(items));
				// setCartAction(items);
				return items;
			})
			.catch((error) => {
				console.log("error here", error);
			});
	}
};

// add item to cart : typical action
export const addToCartUnsafe = (product, qty) => ({
	type: types.ADD_TO_CART,
	product,
	qty,
});

// add item to cart : typical action
// export const addToCartUnsafe = ( product, qty ) => ( {
//     type: types.ADD_TO_CART,
//     product,
//     qty
// } );

// remove item from wishlist
export const removeFromWishlist = (productId) => (dispatch) => {
	toast.error("Item removed from Wishlist");
	dispatch({
		type: types.REMOVE_FROM_WISHLIST,
		productId,
	});
};

// add item to cart from wishlist
export const addToCartFromWishlist = (product, qty) => (dispatch) => {
	toast.success("Item added to Cart");

	dispatch({
		type: types.REMOVE_FROM_WISHLIST,
		productId: product.id,
	});

	dispatch(addToCartUnsafe(product, qty));
};

// remove item from cart
export const removeFromCart = (productId) => async (dispatch) => {
	if (!token) {
		await axiosClient.delete(
			`tempcart/${localStorage.getItem("cart_id")}/${productId}`
		);
	} else {
		try {
			await axiosClient.delete(`cart/${productId}`, {
				headers: {
					Authorization: `Bearer ${token}`,
				},
			});
		} catch (e) {
			toast.error("Item removed from Cart");
		}
	}

	dispatch({
		type: types.REMOVE_FROM_CART,
		productId,
	});
};

// change item's qty
export const changeQty = (productId, qty) => ({
	type: types.CHANGE_QTY,
	productId,
	qty,
});

// change shipping method
export const changeShipping = (shipping) => ({
	type: types.CHANGE_SHIPPING,
	shipping,
});

/*********** Wishlist Action *********/

export const setWishlist = () => (dispatch) => {
	// toast.success( "Item Added to Cart" );
	// if (token) {
	const user = JSON.parse(localStorage.getItem("delyork_user"));

	axiosClient
		.get(`wishlist/${user && user.email}`, {
			headers: {
				Authorization: `Bearer ${token}`,
			},
		})
		.then((data) => {
			console.log("wishlist", data);
			const items = data.data;
			console.log("cart items", items);
			dispatch(setWishlistAction(items));
			return items;
		})
		.catch((error) => {
			console.log(error);
		});
	// } else {
	// axiosClient
	//   .get(`cart`, {
	//     headers: {
	//       Authorization: `Bearer ${token}`,
	//     },
	//   })
	//   .then((data) => {
	//     const items = data.data
	//     console.log('cart items', items)
	//     setCartAction(items)
	//      return items
	//   })
	//   .catch((error) => {
	//     console.log('error here',error)
	//   })
	// }
};

// add item to wishlist : typical action
export const setWishlistAction = (products) => ({
	type: types.SET_WISHLIST,
	products,
});

// add item to wishlist
export const toggleWishlist = (product, email) => async (dispatch) => {
	//  alert(JSON.stringify(user))

	if (user && user.email) {
		const { data } = await axiosClient.post(
			`wishlist/toggle/${user.email}/${product.id}`
		);
		// dispatch(setWishlistAction(data));
		dispatch(toggleWishlistUnsafe(product, data));
	} else {
		// alert('ok')
		// alert(JSON.stringify(user))
		return (window.location.href = "/pages/login");
	}
};

// add item to wishlist : typical action
export const toggleWishlistUnsafe = (product, data) => ({
	type: types.TOGGLE_WISHLIST,
	product,
	items: data,
});

/************* Compare Action ***********/
// add to comparelist
export const addToCompare = (product) => (dispatch) => {
	axiosClient.post("/cart");
	toast.success("Item added to Compare");
	dispatch(addToCompareUnsafe(product));
};

export const addToCompareUnsafe = (product) => ({
	type: types.ADD_TO_COMPARE,
	product,
});

// remove all items from cartlist
export const removeFromCompare = (productId) => (dispatch) => {
	toast.success("Compare item removed");
	dispatch(removeFromCompareUnsafe(productId));
};

export const removeFromCompareUnsafe = (productId) => ({
	type: types.REMOVE_FROM_COMPARE,
	productId,
});

// reset cartlist with intialstate
export const resetCompare = () => ({
	type: types.RESET_COMPARE,
});

/************** Filter Action ***********/

// set order to sort
export const filterSort = (sortBy) => (dispatch) => {
	dispatch({
		type: types.SORT_BY,
		sortBy,
	});
};

// set price range to get suitable products
export const filterPrice = (range) => (dispatch) => {
	dispatch({
		type: types.PRICE_FILTER,
		range,
	});
};

// add/remove category to get suitable products
export const toggleCategoryFilter = (category) => (dispatch) => {
	dispatch({
		type: types.CATEGORY_FILTER,
		category,
	});
};

// add/remove product size to get suitable products
export const toggleSizeFilter = (size) => (dispatch) => {
	dispatch({
		type: types.SIZE_FILTER,
		size,
	});
};

// add/remove color to get suitable products
export const toggleColorFilter = (color) => (dispatch) => {
	dispatch({
		type: types.COLOR_FILTER,
		color,
	});
};

// add/remove brand to get suitable products
export const toggleBrandFilter = (brand) => (dispatch) => {
	dispatch({
		type: types.BRAND_FILTER,
		brand,
	});
};

// add/remove rating to get suitable products
export const toggleRatingFilter = (rating) => (dispatch) => {
	dispatch({
		type: types.RATING_FILTER,
		rating,
	});
};

// reset filter with intialstate
export const resetFilter = () => (dispatch) => {
	dispatch({
		type: types.RESET_FILTER,
	});
};

/************** Newsletter Modal ************/

// hide newsletter modal in homepage
export const hideNewsletterModal = () => ({
	type: types.HIDE_NEWSLETTER_MODAL,
});

// set featured products
export const setFeaturedProducts = (products) => ({
	type: types.SET_FEATURED_PRODUCTS,
	products,
});

// set top products
export const setTopProducts = (products) => ({
	type: types.SET_TOP_PRODUCTS,
	products,
});

// set top products
export const setTrendingProducts = (data) => ({
	type: types.SET_TRENDING_PRODUCTS,
	data,
});

/************* Compare Action ***********/
// add to comparelist
export const startSetProductsHomepage = () => (dispatch) => {
	Axios.all([
		axiosClient.get("/product-query?type=featured"),
		axiosClient.get("/product-query?type=top"),
		axiosClient.get("/product-query?type=trending-products"),
	])
		.then(
			Axios.spread((featured, top, trendingProducts) => {
				dispatch(setFeaturedProducts(featured.data.data));
				dispatch(setTopProducts(top.data.data));
				dispatch(setTrendingProducts(trendingProducts.data.data));
			})
		)
		.catch((e) => console.log(e));
};

// .then(Axios.spread((featured, top) => {
//     dispatch(setFeaturedProducts(featured),
//     dispatch(setTopProducts(top))).catch((e)=> console.log(e))

export const setUpdateCart = (qty) => (dispatch) => {
	// toast.success( "Item Added to Cart" );
	if (!token) {
		const session = localStorage.getItem("cart_id");
		axiosClient
			.put(`tempcart/${session}`, {
				headers: {
					Authorization: `Bearer ${token}`,
				},
			})
			.then((data) => {
				const items = data.data;
				console.log("cart items", items);
				dispatch(setCartAction(items));
			})
			.catch((error) => {
				console.log(error);
			});
	} else {
		axiosClient
			.put(
				`cart`,
				{ quantity: qty },
				{
					headers: {
						Authorization: `Bearer ${token}`,
					},
				}
			)
			.then((data) => {
				const items = data.data;
				console.log("cart items", items);
				dispatch(setCartAction(items));
			})
			.catch((error) => {
				console.log(error);
			});
	}
};
